module.exports = __webpack_public_path__ + "img/stress_resilience.45d57d8b.png";